export const EMPTY_STUDY_FILTER = { q: "", clinic_id: "", from: "", to: "" };

// Open, case-insensitive search over patient name, case number and clinic name,
// plus clinic and date-range filters.
export function filterStudies(list, f) {
  const q = (f.q || "").trim().toLowerCase();
  return list.filter((b) => {
    if (f.clinic_id && b.clinic_id !== f.clinic_id) return false;
    if (f.from && b.slot_date < f.from) return false;
    if (f.to && b.slot_date > f.to) return false;
    if (q) {
      const hay = `${b.patient_name || ""} ${b.case_number || ""}`.toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}
